import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CoreModule } from 'app/core/core.module';
import { TicketsAndGuestsListComponent } from 'app/manage-tickets-and-guests/components/tickets-and-guests-list/tickets-and-guests-list.component';

@Component({
  selector: 'app-ticketing-report-page',
  standalone: true,
  imports: [TicketsAndGuestsListComponent,CommonModule,CoreModule],
  templateUrl: './ticketing-report-page.component.html',
  styleUrl: './ticketing-report-page.component.scss'
})
export class TicketingReportPageComponent implements OnInit,OnDestroy {

  @ViewChild('manageTicketingPage', { static: true }) manageTicketingPageRef: ElementRef;
    
  ngOnInit(): void {
      
  }
  
  ngAfterViewInit(): void {
    const campaignStyles = window['documentManager'].createElement('link');
    campaignStyles.href = 'paybee-spa/styles.css?v=398';
    campaignStyles.rel = 'stylesheet';
    window['$'](this.manageTicketingPageRef.nativeElement).append(campaignStyles);
  }
  
  ngOnDestroy(): void {
    const $ = window['$'];
    $("#manageTicketingPage").hide();
    $("#manageTicketingPage").empty();
  }
}
